import React, { useEffect, useState } from "react";
import {
  getVideos,
  deleteVideo,
  updateVideo,
} from "../../../Api/Speakers/Videoes";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import AddVideosModal from "./AddVideosModal";
import EditVideoModal from "./EditVideoModal";
import { createVideo } from "../../../Api/Speakers/Videoes";
import { toast } from "react-toastify";

const VideosManagement = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [videos, setVideos] = useState({ items: [], total: 0 }); // للجدول
  const [currentVideo, setCurrentVideo] = useState(null); // للفيديو عند التعديل

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    englishTitle: "",
    arabicTitle: "",
    englishDescription: "",
    arabicDescription: "",
    link: "",
  });

  toast.dismiss();
  const getYoutubeId = (url) => {
    if (!url || typeof url !== "string") return "";
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^\s&?/]+)/
    );
    return match ? match[1] : "";
  };

  const loadVideos = async () => {
    try {
      const response = await getVideos({ page: 1, pageSize: 10 });
      console.log(response);
      setVideos({
        items: response.data.items || [],
        total: response.data.metadata?.totalCount || 0,
      });
    } catch (error) {
      console.error("Error fetching books:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentVideo) {
      setFormData({
        englishTitle: currentVideo.englishTitle || "",
        arabicTitle: currentVideo.arabicTitle || "",
        englishDescription: currentVideo.englishDescription || "",
        arabicDescription: currentVideo.arabicDescription || "",
        link: currentVideo.link || "",
      });
    } else {
      setFormData({
        englishTitle: "",
        arabicTitle: "",
        englishDescription: "",
        arabicDescription: "",
        link: "",
      });
    }
  }, [currentVideo]);

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentVideo(null); // نفرغ الفيديو الحالي عند الإغلاق
  };

  const handleEditClick = (video) => {
    setCurrentVideo(video); // نحدد الفيديو الحالي
    setIsModalOpen(true);
  };

  const handleDeleteClick = async (videoId) => {
    const confirmDelete = window.confirm(t("are_you_sure_you_want_to_delete"));
    if (!confirmDelete) return;

    try {
      await deleteVideo(videoId);
      toast.success(t("video_deleted_successfully"));
      const response = await getVideos({
        page: page,
        pageCount: pageCount,
      });
      setVideos({
        items: response.data.items || [],
        total: response.data.metadata?.totalCount || 0,
      });
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error(t("error_deleting_video"));
    }
  };

  const handleUpdateVideo = async (formData) => {
    try {
      const response = await updateVideo(currentVideo.id, formData);
      console.log(response);
  
      setVideos((prevVideos) => {
        const updatedVideos = prevVideos.items.map((video) =>
          video.id === currentVideo.id ? { ...video, ...formData } : video
        );
        return { ...prevVideos, items: updatedVideos };
      });
  
      await loadVideos();
      toast.success(t("video_updated_successfully"));
      setIsModalOpen(false);
      setCurrentVideo(null);
    } catch (error) {
      console.error("Update Error:", error);
      toast.error(t("error_updating_video"));
    }
  };
  

  const handleAddVideo = async (formData) => {
    try {
      const response = await createVideo(formData);
      toast.success(t("video_added_successfully"));
      setVideos({
        items: [...videos.items, response.data], // إضافة الفيديو الجديد مباشرة إلى الجدول
        total: videos.total + 1,
      });
      setIsModalOpen(false);
    } catch (error) {
      toast.error(t("error_adding_video"));
    }
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    loadVideos();
  }, []);

  return (
    <div
      className="tab-pane fade show active"
      id="videos"
      role="tabpanel"
      aria-labelledby="videos-tab"
      dir={languageDirection}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>{t("videos_management")}</h3>
        <button
          className="btn btn-primary"
          onClick={() => setIsModalOpen(true)}
        >
          <i className="fas fa-plus me-2"></i> {t("add_new_video")}
        </button>
      </div>

      {/* Videos Table */}
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-light">
            <tr>
              <th width="70">#</th>
              <th width="120">{t("thumbnail")}</th>
              <th>{t("video_title_ar")}</th>
              <th>{t("video_title_en")}</th>
              {/* <th width="100">{t("date")}</th> */}
              <th width="150">{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  {t("loading")}...
                </td>
              </tr>
            ) : videos.items.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="empty-state">
                    <i className="fas fa-video fa-3x mb-3 text-muted"></i>
                    <h5 className="text-muted">{t("no_videos_yet")}</h5>
                    <p className="text-muted small">
                      {t("press_add_to_create_video")}
                    </p>
                  </div>
                </td>
              </tr>
            ) : Array.isArray(videos?.items) && videos.items.length > 0 ? (
              videos.items.map((video, index) => (
                <tr key={video.id}>
                  <td>{index + 1}</td>
                  <td>
                    {video.link ? (
                      <img
                        src={`https://img.youtube.com/vi/${getYoutubeId(
                          video.link
                        )}/0.jpg`}
                        alt="thumb"
                        className="img-fluid"
                      />
                    ) : (
                      <img
                        src="/images/placeholder-thumbnail.jpg"
                        alt="No thumbnail"
                        className="img-fluid"
                      />
                    )}
                  </td>
                  <td>{video?.arabicTitle || t("no_title_available")}</td>
                  <td>{video?.englishTitle || t("no_title_available")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEditClick(video)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDeleteClick(video.id)}
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : null}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      <AddVideosModal
        show={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={currentVideo ? handleUpdateVideo : handleAddVideo}
        onSuccess={loadVideos}
        video={currentVideo}
      />
    </div>
  );
};

export default VideosManagement;
